import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { Cart } from './pages/Cart';
import { About } from './pages/About';
import { FAQPage } from './pages/FAQPage';
import { Category } from './pages/Category';
import { Logos } from './pages/Logos';
import { Articles } from './pages/Articles';
import { ArticleDetail } from './pages/ArticleDetail';
import { Bundles } from './pages/Bundles';
import { VialLab } from './pages/VialLab';
import { CartProvider } from './components/cart/CartContext';
import { CartDrawer } from './components/cart/CartDrawer';
import { PRODUCTS } from './components/products';
export function App() {
  return <BrowserRouter data-id="element-0">
      <CartProvider products={PRODUCTS} data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/shop" element={<Shop data-id="element-6" />} data-id="element-5" />
          <Route path="/shop/category/:slug" element={<Category data-id="element-8" />} data-id="element-7" />
          <Route path="/shop/:slug" element={<ProductDetail data-id="element-10" />} data-id="element-9" />
          <Route path="/bundles" element={<Bundles data-id="element-12" />} data-id="element-11" />
          <Route path="/articles" element={<Articles data-id="element-14" />} data-id="element-13" />
          <Route path="/articles/:slug" element={<ArticleDetail data-id="element-16" />} data-id="element-15" />
          <Route path="/cart" element={<Cart data-id="element-18" />} data-id="element-17" />
          <Route path="/about" element={<About data-id="element-20" />} data-id="element-19" />
          <Route path="/faq" element={<FAQPage data-id="element-22" />} data-id="element-21" />
          <Route path="/logos" element={<Logos data-id="element-24" />} data-id="element-23" />
          <Route path="/vial-lab" element={<VialLab data-id="element-26" />} data-id="element-25" />
        </Routes>
        <CartDrawer data-id="element-27" />
      </CartProvider>
    </BrowserRouter>;
}